import { useMemo, useState } from "react";
import { WORK_HISTORY } from "../constants";
import Company from "./Company";

import "./Timeline.css";
import { Position } from "../../types/WorkHistory";

export default function Timeline() {
  const [expandedPosition, setExpandedPosition] = useState<Position | null>(null);

  const workHistoryWithFloats = useMemo(() => {
    let float = 0; // 0 === 'left' || 1 === 'right'

    return WORK_HISTORY.reduce(
      (acc, curr) => {
        acc.push({
          ...curr,
          positions: curr.positions.map((position) => {
            const positionFloat = float === 0 ? "left" : "right";
            float = float === 0 ? 1 : 0;

            return { ...position, float: positionFloat };
          }),
        });
        return acc;
      },
      [] as typeof WORK_HISTORY,
    );
  }, []);

  return (
    <div className="timeline">
      {workHistoryWithFloats.map((company, index) => (
        <Company
          key={index}
          company={company}
          expandedPosition={expandedPosition}
          setExpandedPosition={setExpandedPosition} />
      ))}
    </div>
  );
}
